// extracted by mini-css-extract-plugin
module.exports = {"postsPagination":"PostsListing_postsPagination__Pr0Qm","paginationActive":"PostsListing_paginationActive__plnO3"};